import TarifsConfig from './_config/tarifs.config';
import TarifsComponent from './components/tarifs';
import GrillesComponent from './components/grilles';
import TarifsService from './services/tarifs.service';
import GrilleErrorsComponent from './components/grille-errors-component';

const moduleName = 'app.massia.gestion.tarifs';

angular
    .module(moduleName, [])
    .config(TarifsConfig)
    .service('TarifsService', TarifsService)
    .component('tarifs', TarifsComponent)
    .component('grilles', GrillesComponent)
    .component('grilleError', GrilleErrorsComponent);

export default moduleName;
